import { useI18n } from "@/hooks/useI18n";
import { dictionary } from "@/lib/i18n";
import {
  Award,
  TrendingDown,
  Settings2,
  Workflow,
  ShieldCheck,
  Target,
} from "lucide-react";

const ICONS = { Award, TrendingDown, Settings2, Workflow, ShieldCheck, Target };

export const Advantages = () => {
  const { lang } = useI18n();
  const data = dictionary.advantages;

  return (
    <section
      id="advantages"
      data-testid="advantages-section"
      className="relative py-24 md:py-28 bg-[#F5F8FC] border-b border-[#E2E8F0]"
    >
      <div className="container mx-auto px-6 md:px-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-end mb-12">
          <div className="lg:col-span-7">
            <span
              data-testid="advantages-label"
              className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#1857D6]"
            >
              ▍ {data.label[lang]}
            </span>
            <h2
              data-testid="advantages-title"
              className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0A1933] leading-[1.1]"
              style={{ fontFamily: "Manrope, IBM Plex Sans, sans-serif" }}
            >
              {data.title[lang]}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {data.items.map((item, idx) => {
            const Icon = ICONS[item.icon] || Award;
            return (
              <article
                key={idx}
                data-testid={`advantage-card-${idx}`}
                className="group relative bg-white hover:bg-[#0F2756] transition-colors duration-300 p-7 lg:p-9 min-h-[230px] flex flex-col"
              >
                <div className="flex items-start justify-between mb-7">
                  <div className="h-12 w-12 flex items-center justify-center bg-[#0F2756]/5 border border-[#0F2756]/15 group-hover:bg-white/10 group-hover:border-white/30 transition-colors">
                    <Icon className="h-5 w-5 text-[#1857D6] group-hover:text-[#4FC3F7] transition-colors" />
                  </div>
                  <span className="text-[10px] tracking-[0.3em] text-[#94A3B8] group-hover:text-white/50 font-bold transition-colors">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3
                  className="text-lg lg:text-xl font-bold text-[#0A1933] group-hover:text-white transition-colors leading-snug"
                  style={{ fontFamily: "Manrope, IBM Plex Sans, sans-serif" }}
                >
                  {item.title[lang]}
                </h3>
                <p className="mt-3 text-[14px] text-[#475569] group-hover:text-white/85 leading-relaxed transition-colors">
                  {item.desc[lang]}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
